import React from "react";
import { IInputDate } from "./interface";
import DatePicker from "react-datepicker";
import { setHours, setMinutes } from "date-fns"; // Tambahkan impor ini

import "./input.scss";
const Component: React.FC<IInputDate> = ({
  startDate,
  onChange,
  placeholder,
  dateNow,
}) => {
  return (
    <>
      <div className="w-100">
        <DatePicker
          selected={startDate}
          onChange={onChange}
          showTimeSelect
          minDate={dateNow ? new Date() : null}
          onKeyDown={(e) => {
            e.preventDefault();
          }}
          placeholderText={placeholder || ""}
          dateFormat="MMMM d, yyyy h:mm aa"
        />
      </div>
    </>
  );
};

export default Component;
